import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { getCompanyKnowledgeGuideAPI, getKnowledgeCenterAPI, getKnowledgeGuideLinksAPI } from "./api";
import { getCompanyKnowledgeGuideFailed, getCompanyKnowledgeGuideSuccess, getKnowledgeCenterFail, getKnowledgeCenterSuccess, getKnowledgeGuideLinksFailed, getKnowledgeGuideLinksSuccess } from "./actions";
import { GET_COMPANY_KNOWLEDGE_GUIDE, GET_KNOWLEDGE_CENTER, GET_KNOWLEDGE_GUIDE_LINKS } from "./constants";

function* getKnowledgeCenterAsync(payload) {
    try {


        const response = yield call(getKnowledgeCenterAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(getKnowledgeCenterSuccess(response.data.data))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getKnowledgeCenterFail(error.response.data.error || "Unable to Get Files"))
    }
}




function* getCompanyKnowledgeGuideAsync(payload) {
    try {

        const response = yield call(getCompanyKnowledgeGuideAPI, payload.payload)
        if (response && response.status === 200) {
            yield put(getCompanyKnowledgeGuideSuccess(response.data.data))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getCompanyKnowledgeGuideFailed(error.response.data.error || "Something Unexpected error occured, please try again"))
    }
}

function* getKnowledgeGuideLinksAsync(payload) {
    try {

        const response = yield call(getKnowledgeGuideLinksAPI, payload.payload)
        if (response && response.status === 200) {
            yield put(getKnowledgeGuideLinksSuccess(response.data.data))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getKnowledgeGuideLinksFailed(error.response.data.error || "Something Unexpected error occured, please try again"))
    }
}



function* mainKnowledgeCenterSaga() {

    yield takeEvery(GET_KNOWLEDGE_CENTER, getKnowledgeCenterAsync)
    yield takeEvery(GET_COMPANY_KNOWLEDGE_GUIDE, getCompanyKnowledgeGuideAsync)
    yield takeEvery(GET_KNOWLEDGE_GUIDE_LINKS, getKnowledgeGuideLinksAsync)
    // yield takeEvery(GET_KNOWLEDGECENTER_DOC, getKnowledgeCenterDoc)
    // yield takeEvery(RM_KNOWLEDGECENTER_DOC, rmKnowledgeCenterDoc)
    //yield takeLatest(LOGOUT_SU_USER, logoutUser)
}

export default mainKnowledgeCenterSaga;
